module.exports = __webpack_public_path__ + "f681656f74b9ee9ab7e77d53c315ab13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/assets/charles.jpg
// module id = 1043
// module chunks = 0